import { makeStyles } from '@material-ui/core';
import ArchitectureLogoImage from './architecture-logo.png';

const useStyles = makeStyles({
  image: {
    width: 'auto',
    height: 48,
  },
  l: {
    width: 'auto',
    height: 180,
  },
  xl: {
    width: 'auto',
    height: 240,
  },
});

const ArchitectureLogo = ({ size }: { size?: 'xl' | 'l' }) => {
  const classes = useStyles();
  return (
    <img
      alt="Architecture Logo"
      className={size ? classes[size] : classes.image}
      src={ArchitectureLogoImage}
    />
  );
};

export default ArchitectureLogo;
